import CaptchaTypeTableService from 'app/admin/captchatype/service/CaptchaTypeTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'captchaTypeTable',
	text: 'Captcha Type',
	topic: 'captchaType',
	service: CaptchaTypeTableService,
	icon: 'person',
	editFormState: item => `/captchatype/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'search', 'refresh', 'new'],
	filterFields: [
		{
			propertyName: 'name',
			propertyType: 'String',
			type: 'LIKE'
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'name',
			text: 'Name',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'captchaFamily',
			text: 'Captcha Family',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function CaptchaTypeTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('captchaTypeTable', reducer('captchaTypeTable'))(CaptchaTypeTable);
